// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';

export interface HistogramDataset {
    label: string;
    data: number[];
    backgroundColor: string;
}

type NullableNumber = number | null | undefined;

export interface UserReportInfo {
    annotatingTime: number;
    drawCount: NullableNumber;
    deleteCount: NullableNumber;
    updateCount: NullableNumber;
    annotationSpeed: number;
    frameCount: number;
    issueCount: number;
    score: number;
    userId: number;
    userName: string;
}

interface Props {
    data: UserReportInfo[];
}

function UserReportTable(props: Props): JSX.Element | null {
    const { data } = props;
    // TODO: 标注速度要记录标注员的标注数比上在标注页面的停留时间，目前的实现不是这样的因此前端没有展示
    return (
        <table>
            <thead>
                <tr>
                    <th>用户ID</th>
                    <th>用户名</th>
                    <th>帧数量</th>
                    <th>创建标注数量</th>
                    <th>删除标注数量</th>
                    <th>更新标注数量</th>
                    <th>问题数量</th>
                    <th>标注合格率</th>
                    <th>标注时间（小时）</th>
                    <th>平均标注时间（标注数/标注时间）</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.userId}</td>
                        <td>{item.userName}</td>
                        <td>{item.frameCount}</td>
                        <td>{item.drawCount}</td>
                        <td>{item.deleteCount}</td>
                        <td>{item.updateCount}</td>
                        <td>{item.issueCount}</td>
                        <td>{item.score}</td>
                        <td>{item.annotatingTime}</td>
                        <td>{item.annotationSpeed}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default React.memo(UserReportTable);
